import React from 'react';
import { connect } from 'react-redux';
import CONSTANTS from '../../../constants';
import { pushEventToGTM } from '../../../helpers/trackerManager';
import * as moment from 'moment'
import Icon from '../../buttons/Icon';
import { selectedServices, setSelectedPremiumServicesToStore } from '../../../actions/action';
import { priceFormat } from '../../../helpers/functions';

const mapDispatchToProps = { selectedServices, setSelectedPremiumServicesToStore };

const mapStateToProps = state => state;
class OperationItemSummary extends React.PureComponent {
	_isMounted = false;
	static defaultProps = {
		isForfait: false,
		isServicePremium: false,
		forfait: {},
		Service: {}
	};
	constructor(props) {
		super(props);
		this.state = {
			pageLoaded: false,
			showDetails: false,
			totalPrice: 0,
			showObligatoryMessage: false,

		};
		this.removeThatForfait = this.removeThatForfait.bind(this);
		this.removeServicePremium = this.removeServicePremium.bind(this);
		this.calculateforfaitPrice = this.calculateforfaitPrice.bind(this);
	}
	componentWillMount() {
		this._isMounted = true;
	}
	componentDidMount() {
		this.calculateforfaitPrice();
	}

	componentWillUnmount() {
		this._isMounted = false;
	}
	componentDidUpdate(prevProps, prevState) {
		this.calculateforfaitPrice();
	}
	verifyRDVdateLimit() {
		var dateLimit = this.props.store.dateLimitModif;
		if (this.props.store.isEditMode) {
			var limit = moment(dateLimit).format('YYYY/MM/DD');
			var now = moment().format('YYYY/MM/DD');
			if (now < limit) {
				this.setState({ expiredDate: false });
			} else {
				this.setState({ expiredDate: true });
			}
		}
	}
	calculateforfaitPrice() {
		let price = 0;
		!!this.props.forfait.forfaits && Object.values(this.props.forfait.forfaits).forEach((forfait, fkey) => {
			!!Object.values(forfait.SubFunctionList).length &&
				forfait.SubFunctionList[0].ForfaitList.forEach((forfaitItem, fikey) => {
					if (forfaitItem.isSelected) {
						price += forfaitItem.Items[0].Prix;
					}
					if (forfaitItem.isSelected && forfaitItem.Operations) {
						forfaitItem.Operations.forEach((operation, OpKey) => {
							if (operation.isSelected) {
								price += operation.Items[0].Prix;
							}
						});
					}
				});
		});
		this.setState({ totalPrice: price });
		console.log(price);
	}
	removeServicePremium(serviceid) {
		const filtredServices = Object.values(this.props.store.selectedPremiumServices).filter(item => item.idServicePremium !== serviceid);
		this.props.setSelectedPremiumServicesToStore(filtredServices);
	}
	removeThatForfait(interventionID) {
		const selectedServices = Object.assign({}, this.props.store.SelectedServices);
		const filtredServices = Object.values(selectedServices).filter(item => (item.interventionId !== interventionID));
		this.props.selectedServices(filtredServices);
	}
	render() {
		this.verifyRDVdateLimit();
		const happyDiscount = Number(this.props.store.booking.happy);
		const showObligatoryMessage = this.state.showObligatoryMessage;

		if (!this.props.isServicePremium)
			return (
				<React.Fragment>
					<div className="operation-item">

						<p className="title"><span className="titre">{this.props.forfait.interventionLabel}</span>
							{this.props.isForfait && !!this.state.totalPrice && window.isMobile() == 'desktop' &&
								<span
									className="show-details"
									tabIndex='0'
									onKeyDown={(e) => {
										if (e.key === 'Enter') {

											pushEventToGTM({
												pageName: 'summary',
												eventAction: 'Display::Details',
												eventLabel: 'summary_detail'
											});
											this.setState({ showDetails: !this.state.showDetails });
										}
									}}
									onClick={() => {

										pushEventToGTM({
											pageName: 'summary',
											eventAction: 'Display::Details',
											eventLabel: 'summary_detail'
										});
										this.setState({ showDetails: !this.state.showDetails });
									}
									}
								>
									{CONSTANTS.LABELS.common_v2_detail}
								</span>}
							{!this.state.totalPrice && <span className="title-description" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.summary_operation_operationlist_noprice) }}></span>}

						</p>
						<div className="price">
							{this.props.isForfait && !!this.state.totalPrice && <React.Fragment>
								<strong>{(!!happyDiscount ? priceFormat(this.state.totalPrice - (this.state.totalPrice * 0.01 * happyDiscount).toFixed(3)) : priceFormat(this.state.totalPrice) )}{` ${CONSTANTS.LABELS.needs_basket_label2}`} </strong>
								{!!happyDiscount && <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_discount_applied) }}></span>

								}
							</React.Fragment>}
							{ /*
			  			 	 		   * show info icon in case there is no forfait => no price selected
			  			 	 		   * 

			  			 	 		!this.state.totalPrice && <Icon Name="info-active" />
			  			 	 		*/}
						</div>

						{this.state.expiredDate === false ?
							<div className="remove">
								<Icon Name="delete" onClick={(e) => this.removeThatForfait(this.props.forfait.interventionId)} />
							</div> : null}

					</div>
					{this.props.isForfait && !!this.state.totalPrice && window.isMobile() != 'desktop' && <span className="show-details" onClick={() => this.setState({ showDetails: (this.state.showDetails ? false : true) })}>{CONSTANTS.LABELS.common_v2_detail}</span>}

					<div className="operation-item-details" >
						<ul className="item-operations ">
							{this.props.isForfait &&
								this.state.showDetails &&
								Object.values(this.props.forfait.forfaits).map(function (forfait, fkey) {
									console.warn(this.props.forfait.forfaits);
									return (<React.Fragment key={fkey}>
										{forfait.SubFunctionList && forfait.SubFunctionList[0].ForfaitList.map(function (forfaitItem, fikey) {
											if (!forfait.isConstructeur)
												return (forfaitItem.isSelected && <li className="item-wrapper" key={fikey}>
													<span tabIndex="0" className="item-label"> {forfaitItem.Libelle}</span>
													<span tabIndex="0" className="item-price">{(!!happyDiscount ? priceFormat(forfaitItem.Items[0].Prix - (forfaitItem.Items[0].Prix * 0.01 * happyDiscount).toFixed(2)) : priceFormat(forfaitItem.Items[0].Prix))}{` ${CONSTANTS.LABELS.needs_basket_label2}`} </span>

												</li>)
											else
												return (forfait.isConstructeur && forfaitItem.isSelected && <React.Fragment key={fikey}>
													<li className="item-wrapper no-border">
														<span tabIndex="0" className="item-label"> {forfaitItem.Libelle}</span>
														<span tabIndex="0" className="item-price">{(!!happyDiscount ? priceFormat(forfaitItem.Items[0].Prix - (forfaitItem.Items[0].Prix * 0.01 * happyDiscount).toFixed(2)) : priceFormat(forfaitItem.Items[0].Prix))}{` ${CONSTANTS.LABELS.needs_basket_label2}`}</span>
													</li>
													<li className="item-wrapper operation-section no-border">
														<span tabIndex="0" className="item-label" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.summary_operation_complementary) }}></span>
														<span className="item-price">
															<Icon Name="info-active"
																onClick={() => this.setState({ showObligatoryMessage: (this.state.showObligatoryMessage ? false : true) })} />
														</span>

														{showObligatoryMessage && <p tabIndex="0" className="item-details" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_label8) }}></p>}

													</li>

													{forfaitItem.Operations && forfaitItem.Operations.map((operation, OpKey) => {
														return (operation.isSelected && <li className="item-wrapper" key={OpKey}>
															<span tabIndex="0" className="item-label"> {operation.Libelle}</span>
															<span tabIndex="0" className="item-price">{(!!happyDiscount ? priceFormat(operation.Items[0].Prix - (operation.Items[0].Prix * 0.01 * happyDiscount).toFixed(2)) : priceFormat(operation.Items[0].Prix))}{` ${CONSTANTS.LABELS.needs_basket_label2}`}</span>
														</li>)

													})}

												</React.Fragment>)
										}.bind(this))}



									</React.Fragment>)

								}.bind(this))}
						</ul>
					</div>
				</React.Fragment>

			)
		else
			return (

				<React.Fragment>
					<div className="operation-item service-premium">
						<p className="title">{this.props.Service.titre}
						</p>
						<div className="price">
							{//this.props.Service.Price > 0 && <strong>{this.props.Service.Price} {CONSTANTS.LABELS.needs_basket_label2}</strong>}
								//this.props.Service.Price < 1 && <strong  dangerouslySetInnerHTML={{__html:(CONSTANTS.LABELS.userinfos_options_mobility_price)}}></strong>	 
							}
							{/* <strong dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.userinfos_options_mobility_price) }}></strong> */}
							<strong>{this.props.Service.Price}</strong>

						</div>
						{this.state.expiredDate == false ?
							<div className="remove">
								<Icon Name="delete" onClick={(e) => this.removeServicePremium(this.props.Service.idServicePremium)} />
							</div> : null}
					</div>
				</React.Fragment>
			)
	}
}



export default connect(mapStateToProps, mapDispatchToProps)(OperationItemSummary);
